import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ThreadCard } from 'legacyComponents/cards/types/thread';
import { ForumCard } from 'legacyComponents/cards/types/forum';

import { staticURL } from 'core/url';
import { ConnectConversationsManager } from 'apps/home/connect/conversations/appManager';
import { ContentIntro } from 'apps/components/contentIntro';
import { conf } from 'apps/home/connect/config.yaml';

@withNamespaces()
@inject('routerStore')
@observer
export class ConnectConversations extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ConnectConversationsManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const featuredConnection = this.appManager.featuredForumsConn;
    const featuredForums = featuredConnection.arrayApp;

    const connection = this.appManager.threadsConn;
    const threads = connection.arrayApp;
    return (
      <>
        <Header />
        <ContentIntro
          title={conf.conversations.title}
          description={conf.conversations.description}
          createButtonText='Join the Conversation'
          createButtonLink='home.signIn'
          hideButtonWhenSignIn={true}
          variant='primary'
          isCentered
          textCenter
          addSpacer
          hideIfSignedIn
          marginBottom='8rem'
          backgroundLayer={
            <>
              <img
                src={staticURL('assets/contentInfoBackgrounds/greyCircle.svg')}
                alt='background-image'
              />
              <img
                src={staticURL(
                  'assets/contentInfoBackgrounds/blueTriangleBottomCircleTop.svg',
                )}
                alt='background-image'
              />
            </>
          }
        />
        <MainWrapper marginTop='2em'>
          {featuredConnection.loadingMore || featuredForums.length > 0 ? (
            <CardSection
              invisible={this.appManager.loading}
              title='Featured Forums'
              subTitle={' '}
              isOwnProfile={false}
              ownerName=''
              cardApp={featuredForums}
              CardComponent={ForumCard}
              noDataCardType='profile'
              gridColumns={3}
              first
              noSort
            />
          ) : null}
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Threads')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={threads}
            CardComponent={ThreadCard}
            noDataCardType='forumThreads'
            last
          />
        </MainWrapper>
      </>
    );
  }
}

ConnectConversations.propTypes = {
  t: PropTypes.func,
};
